import { tsInitVue } from "./js-utils"
import EventTeamManager from "../js/vue-components/event-team-manager.vue"

document.addEventListener('DOMContentLoaded', () => {
  if (document.querySelector('body.event-teams')) {
    const teamsManagerEl = document.querySelector('div[data-is="EventTeamManager"]')
    if (teamsManagerEl instanceof HTMLElement) {
      window.teamsManager = tsInitVue(EventTeamManager, teamsManagerEl, {
        initialMembers: window.teamMembers as any[] | null,
        initialCoachId: window.teamCoachId as number | null,
        newCandidateUrl: teamsManagerEl.dataset.newCandidateUrl,
        searchCandidatesUrl: teamsManagerEl.dataset.searchCandidatesUrl,
      })
    }
  }
})
